import { MutationTree } from 'vuex'
import { SidebarState } from '../types'
import toggleSidebar from './toggleSidebar'

const mutations: MutationTree<SidebarState> = {
  toggleSidebar,
}

export default mutations
